module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vgal2-a2bd2a0711ab4b06ef455fbfe6373725.jpg";